import { render } from "./Back.vue?vue&type=template&id=701a7e2f&scoped=true&lang=html"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"

import "./Back.vue?vue&type=style&index=0&id=701a7e2f&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701a7e2f"]])

export default __exports__